// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizon-features-tab {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.horizon-feature-row {
  display: flex;
  align-items: stretch;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  overflow: hidden;
  transition: border-color 0.2s ease;
}

.horizon-feature-row:hover {
  border-color: var(--accent-primary);
}

.horizon-feature-row.image-right {
  flex-direction: row-reverse;
}

.horizon-feature-image {
  flex-shrink: 0;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-primary);
  padding: 0.75rem;
}

.horizon-feature-image img {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.horizon-feature-text {
  flex: 1;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.horizon-feature-text h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.6rem;
}

.horizon-feature-text ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.horizon-feature-text li {
  font-size: 0.88rem;
  color: var(--text-secondary);
  line-height: 1.5;
  padding-left: 1rem;
  position: relative;
}

.horizon-feature-text li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--accent-primary);
  font-weight: 700;
}

.horizon-feature-link {
  display: inline-block;
  margin-top: 0.5rem;
  color: var(--accent-primary);
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}

.horizon-feature-link:hover {
  color: var(--accent-hover);
}

@media (max-width: 680px) {
  .horizon-feature-row,
  .horizon-feature-row.image-right {
    flex-direction: column;
  }

  .horizon-feature-image {
    width: 100%;
    max-height: 200px;
  }

  .horizon-feature-text {
    padding: 0.75rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/customTabs/HorizonFeaturesTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".horizon-features-tab {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.horizon-feature-row {\r\n  display: flex;\r\n  align-items: stretch;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.horizon-feature-row:hover {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.horizon-feature-row.image-right {\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.horizon-feature-image {\r\n  flex-shrink: 0;\r\n  width: 180px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--bg-primary);\r\n  padding: 0.75rem;\r\n}\r\n\r\n.horizon-feature-image img {\r\n  width: 100%;\r\n  height: auto;\r\n  object-fit: contain;\r\n  border-radius: 8px;\r\n}\r\n\r\n.horizon-feature-text {\r\n  flex: 1;\r\n  padding: 1rem 1.25rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.horizon-feature-text h3 {\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.6rem;\r\n}\r\n\r\n.horizon-feature-text ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.horizon-feature-text li {\r\n  font-size: 0.88rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.5;\r\n  padding-left: 1rem;\r\n  position: relative;\r\n}\r\n\r\n.horizon-feature-text li::before {\r\n  content: '•';\r\n  position: absolute;\r\n  left: 0;\r\n  color: var(--accent-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.horizon-feature-link {\r\n  display: inline-block;\r\n  margin-top: 0.5rem;\r\n  color: var(--accent-primary);\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.horizon-feature-link:hover {\r\n  color: var(--accent-hover);\r\n}\r\n\r\n@media (max-width: 680px) {\r\n  .horizon-feature-row,\r\n  .horizon-feature-row.image-right {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .horizon-feature-image {\r\n    width: 100%;\r\n    max-height: 200px;\r\n  }\r\n\r\n  .horizon-feature-text {\r\n    padding: 0.75rem 1rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
